import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
body {
    background: #f5f5f5;
}

ul,li {
    padding: 0;
    margin: 0;
    list-style: none;
}
`

export default GlobalStyle;